const InteAgency = () => import(/* webpackChunkName: "inte" */ '@/components/inte/agency');
const InteIntellectualType = () => import(/* webpackChunkName: "inte" */ '@/components/inte/intellectualType');
const InteAgent = () => import(/* webpackChunkName: "inte" */ '@/components/inte/agent');
const InteIntellectualApp = () => import(/* webpackChunkName: "inte" */ '@/components/inte/intellectualApp');
const InteProcessState = () => import(/* webpackChunkName: "inte" */ '@/components/inte/processState');
const InteOutcomeState = () => import(/* webpackChunkName: "inte" */ '@/components/inte/outcomeState');
const InteIntellectualCheck = () => import(/* webpackChunkName: "inte" */ '@/components/inte/intellectualCheck');
const InteIntellectualManage = () => import(/* webpackChunkName: "inte" */ '@/components/inte/intellectualManage');
const InteIntellectualRegist = () => import(/* webpackChunkName: "inte" */ '@/components/inte/intellectualRegist');
const InteIntellectualRegistCheck = () => import(/* webpackChunkName: "inte" */ '@/components/inte/intellectualRegistCheck');
const InteAppManage = () => import(/* webpackChunkName: "inte" */ '@/components/inte/inteAppManage');
const InteManage = () => import(/* webpackChunkName: "inte" */ '@/components/inte/inteManage');
const InteRegistCheckManage = () => import(/* webpackChunkName: "inte" */ '@/components/inte/inteRegistCheckManage');
const InteIntellectualShow = () => import(/* webpackChunkName: "inte" */ '@/components/inte/intellectualShow');
const InteIntellectualView = () => import(/* webpackChunkName: "inte" */ '@/components/inte/view');
export default {
  routes: [
    {
      path: '/inte/agency',
      name: 'inte_agency',
      component: InteAgency
    },
    {
      path: '/inte/intellectualType',
      name: 'inte_intellectualType',
      component: InteIntellectualType
    },
    {
      path: '/inte/agent',
      name: 'inte_agent',
      component: InteAgent
    },
    {
      path: '/inte/intellectualApp',
      name: 'inte_intellectualApp',
      component: InteIntellectualApp
    },
    {
      path: '/inte/processState',
      name: 'inte_processState',
      component: InteProcessState
    },
    {
      path: '/inte/outcomeState',
      name: 'inte_outcomeState',
      component: InteOutcomeState
    },
    {
      path: '/inte/intellectualCheck',
      name: 'inte_intellectualCheck',
      component: InteIntellectualCheck
    },
    {
      path: '/inte/intellectualManage',
      name: 'inte_intellectualManage',
      component: InteIntellectualManage
    },
    {
      path: '/inte/InteIntellectualRegist',
      name: 'inte_InteIntellectualRegist',
      component: InteIntellectualRegist
    },
    {
      path: '/inte/intellectualRegistCheck',
      name: 'inte_intellectualRegistCheck',
      component: InteIntellectualRegistCheck
    },
    {
      path: '/inte/inteAppManage/:dbid',
      name: 'inte_inteAppManage',
      component: InteAppManage
    },
    {
      path: '/inte/inteManage/:dbid',
      name: 'inte_inteManage',
      component: InteManage
    },
    {
      path: '/inte/inteRegistCheckManage/:dbid',
      name: 'inte_inteRegistCheckManage',
      component: InteRegistCheckManage
    },
    {
      path: '/inte/intellectualShow',
      name: 'inte_intellectualShow',
      component: InteIntellectualShow
    },
    {
      path: '/inte/view/:dbid',
      name: 'inte_view',
      component: InteIntellectualView
    }
  ]
}
